import React from 'react';
import Img from 'gatsby-image';
import { useImageQuery } from './useImageQuery';

const RenderSliderImage = (show) => {
	const images = useImageQuery();

	const getImage = () => {
		let item;
		images.allImageSharp.edges.forEach((imageEdge) => {
			if (imageEdge.node.fluid.src.includes(show.name)) {
				item = imageEdge.node;
			}
		});
		console.log({ item });
		return item;
	};

	const image = getImage();

	return (
		<div>
			<div>
				<Img
					className="img-fluid"
					style={{ maxHeight: '533px' }}
					imgStyle={{ objectFit: 'contain' }}
					fluid={image.fluid}
				/>
			</div>
		</div>
	);
};

export default RenderSliderImage;
